'use client';

import { Box } from '@terra/ui-styled-system';
import {
  HeadingItem,
  SegmentedCountBar,
  Skeleton,
  type SegmentedCountBarItem,
} from '@terra/ui-design-system';
import type { MouseEvent } from 'react';
import { formatNumber } from '../../utils/formatNumber';
import { DashboardCard } from './DashboardCard';

const POSTURE_CONTENT_HEIGHT = 72;

type PostureCardProps<TKey extends string> = {
  title: string;
  total: number;
  items: ReadonlyArray<SegmentedCountBarItem<TKey>>;
  isLoading: boolean;
  emptyLabel: string;
  onSelect: (key: TKey) => void;
  onTitleClick: () => void;
  onTitleContextMenu: (event: MouseEvent<HTMLElement>) => void;
};

export function PostureCard<TKey extends string>({
  title,
  total,
  items,
  isLoading,
  emptyLabel,
  onSelect,
  onTitleClick,
  onTitleContextMenu,
}: PostureCardProps<TKey>) {
  return (
    <DashboardCard
      title={title}
      h="full"
      trailingContent={
        isLoading ? (
          <Skeleton height="20px" width="40px" />
        ) : (
          <HeadingItem color="fg.neutral.muted">
            {formatNumber(total)}
          </HeadingItem>
        )
      }
      isLoading={isLoading}
      isEmpty={total === 0}
      emptyLabel={emptyLabel}
      contentHeight={POSTURE_CONTENT_HEIGHT}
      onClick={onTitleClick}
      onContextMenu={onTitleContextMenu}
    >
      <Box w="full" onClick={(event) => event.stopPropagation()}>
        <SegmentedCountBar
          items={items}
          size="md"
          density="compact"
          legendLayout="compact"
          showPercentages={false}
          onSelect={onSelect}
        />
      </Box>
    </DashboardCard>
  );
}
